import { extractLoan } from '../Utils/apiExtractors'
import {
  GET_LOAN_KEY,
  GET_PAPERLESS_KEY,
  GET_TRANSACTIONS_KEY,
} from './api'

export const getItemOrUpdate = async (
  key,
  updaterIfNotInCache,
  refresh = false,
) => {
  let item = getItem(key)

  if (refresh || !item) {
    item = await updaterIfNotInCache()
    setItem(key, item)
    if (key.includes('GET_LOAN_KEY')) {
        localStorage.setItem(
        'loanId', 
        JSON.stringify(item.data.loan.loanData.loanId),
      )



      //  sessionStorage.setItem(
      //   'loanId', 
      //   JSON.stringify(item.data.loan.loanData.loanId),
      // )
      // Also update paperlessIndicator in localStorage
      // This is used to determine if redirect is allowed
      // If paperlessIndicator is OPTIN, set redirectAllowed to true
      const { paperlessIndicator } = extractLoan(item).disclosures

      setItem('ajs_user_traits', paperlessIndicator)
      setItem(GET_PAPERLESS_KEY, paperlessIndicator)

      if (paperlessIndicator === 'OPTIN') {
        setItem('redirectAllowed', true)
      }
    }
  }

  return item
}

export const getItem = (key) => {
  const item = localStorage.getItem(key)
  return item && item !== 'undefined' ? JSON.parse(item) : null
}

export const setItem = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value))
}

export const clearLocalCache = () => {
  localStorage.removeItem(GET_LOAN_KEY)
  localStorage.removeItem(GET_TRANSACTIONS_KEY)
  localStorage.removeItem(GET_PAPERLESS_KEY)
  localStorage.removeItem('ajs_user_traits')

  localStorage.removeItem('redirectAllowed') // Clear redirectAllowed flag
  localStorage.removeItem('mfaJustEnrolled') // Clear first enrolment
  localStorage.removeItem('paperlessOptOut') // Clear first verification
}

export const removeEntry = (key) => {
  localStorage.removeItem(key)
}
